import Vue from 'vue'
import App from './App.vue'
import router from './router'
import localstorage from './utils/localstorage'
import store from './store'
import api from './api' // 导入api接口
import axios from 'axios'
import Echarts from 'echarts'
import ViewUI from 'view-design';
import BaiduMap from 'vue-baidu-map'
import 'view-design/dist/styles/iview.css';
import {Button,Pagination,Swipe,List,PullRefresh,SwipeItem,RadioGroup,Rate,Tab,Tabs,Tag,DropdownMenu,Uploader, DropdownItem,Radio,Cell,Dialog, CellGroup ,Area,DatetimePicker ,SwipeCell , Checkbox, CheckboxGroup,Search, Col,Icon, Field, Image, NavBar, Picker, Popup, Row, Toast, Tabbar, TabbarItem } from 'vant';

Vue.use(Field).use(PullRefresh).use(Rate).use(Swipe).use(SwipeItem).use(Button).use(Tab).use(Tabs).use(Row).use(Col).use(Image).use(Popup).use(Picker).use(Toast).use(Checkbox).use(CheckboxGroup).use(NavBar);
Vue.use(Tabbar).use(Pagination).use(Uploader).use(List).use(Tag).use(DropdownMenu).use(DropdownItem).use(TabbarItem).use(Radio).use(RadioGroup).use(Icon).use(Search).use(Cell).use(CellGroup).use(Area).use(DatetimePicker).use(Dialog).use(SwipeCell);
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$localstorage = localstorage;
Vue.prototype.$axios = axios;
Vue.prototype.echarts = Echarts
Vue.use(ViewUI);
Vue.use(Echarts)
Vue.use(BaiduMap, {
  ak: '8oGIXq7E7OFkDOVzEbiwu5giDGYMCewQ'
})




var onDeviceReady = function() {		
	document.addEventListener("jpush.receiveRegistrationId", function(event) {
//			alert("receiveRegistrationId" + JSON.stringify(event));					
	}, false)
	initiateUI();
};
var getRegistrationID = function() {
	window.JPush.getRegistrationID(onGetRegistrationID);
};
var onGetRegistrationID = function(data) {
	try {
		console.log("JPushPlugin:registrationID is " + data);
		window.localStorage.setItem('registrationId',data)
		if(data.length == 0) {
			var t1 = window.setTimeout(getRegistrationID, 1000);
		}
	} catch(exception) {
		console.log(exception);
	}
};
var onTagsWithAlias = function(event) {
	try {
		console.log("onTagsWithAlias");
		var result = "result code:" + event.resultCode + " ";
		result += "tags:" + event.tags + " ";
		result += "alias:" + event.alias + " ";
	} catch(exception) {
		console.log(exception)
	}
};
var onOpenNotification = function(event) {
	try {
		var alertContent;
		if(device.platform == "Android") {
			alertContent = event.alert;
		} else {
			alertContent = event.aps.alert;
		}
		router.push({name:'myMsg',params: { msgId: event.extras.msg_id }})
//			alert("open Notification:" + alertContent);
	} catch(exception) {
		console.log("JPushPlugin:onOpenNotification" + exception);
	}
};
var onReceiveNotification = function(event) {
	try {
		var alertContent;
		if(device.platform == "Android") {
			alertContent = event.alert;
		} else {
			alertContent = event.aps.alert;
		}
	} catch(exception) {
		console.log(exception)
	}
};
var onReceiveMessage = function(event) {
	try {
		var message;
		if(device.platform == "Android") {
			message = event.message;
		} else {
			message = event.content;
		}
	} catch(exception) {
		console.log("JPushPlugin:onReceiveMessage-->" + exception);
	}
};
var initiateUI = function() {
	try {
		window.JPush.init();
		window.JPush.setDebugMode(true);
		window.setTimeout(getRegistrationID, 1000);
		if(device.platform != "Android") {
			window.JPush.setApplicationIconBadgeNumber(0);
		}
	} catch(exception) {
		console.log(exception);
	}
};
document.addEventListener("deviceready", onDeviceReady, false);
document.addEventListener("jpush.openNotification", onOpenNotification, false);
document.addEventListener("jpush.receiveNotification", onReceiveNotification, false);
document.addEventListener("jpush.receiveMessage", onReceiveMessage, false);




Vue.filter('dataFormat', function (value, fmt) {
    if (null == value || value == '') {
        return '-';
    }
    let getDate
    if(typeof value=="string"){    
    	getDate = new Date(value.replace(/\-/g, "/"));   	   	
    }else{
    	getDate = new Date(value);    	
    }
    let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt;
});

Vue.filter('gender',function(value){
	if(value==null||value==''){
		return '-'
	}
	if(value=='M'){
		return '男'
	}else{
		return '女'
	}
	return '-'
	
})

Vue.filter('orderStatus',function(value){
	if(value==null||value==''){
		return '-'
	}
	if(value=='CD'){
		return '待开始'
	}else{
		return '已结束'
	}
	return '-'
	
})

Vue.filter('preCalss',function(value){
	if(value==null||value==''){
		return '-'
	}
	if(value=='1'){
		return '较差'
	}else if(value=='2'){
		return '一般'
	}else if(value=='3'){
		return '良好'
	}else if(value=='4'){
		return '非常好'
	}
	return '-'
	
})

Vue.filter('actionType',function(value){
	if(value==null||value==''){
		return '-'
	}
	if(value=='S'){
		return '切换递减'
	}else{
		return '切换单一'
	}
	return '-'
	
})

Vue.filter('fixed',function(value,e){
	if(value==null||value==''||isNaN(value)){
		return '-'
	}

	return value.toFixed(e);
	
})


new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
});

